import React from "react";

export interface StillingViewProps {
    stillingLookUp: { stillingId: string, stillingNummer: string, rowIndex: number, uddannelsesstedId: string, afdelingId?: string, collapsed: boolean, aktiv?: boolean };
    visHorizontaleLinjerState: boolean;
    isOnAfdeling?: boolean;
}

export function StillingView(props: StillingViewProps) {
    return <React.Fragment key={props.stillingLookUp.stillingId}>
        <div className={`${props.visHorizontaleLinjerState ? "border-top" :""} stilling-header ${props.stillingLookUp.collapsed ? "collapse" : ""}`}
             style={{"--stilling-rowindex": (props.stillingLookUp.rowIndex)} as React.CSSProperties}>
            <p className={`margin-left-l margin-top-xxs`}>{props.stillingLookUp.stillingNummer}{props.stillingLookUp.aktiv === false && " (Inaktiv)"}</p>
        </div>
    </React.Fragment>
}
